const DATA =  [
  {
    id: 1,
    name: "Newest",
    image: "/TopCategory/img.png",
    link: "/mobiles",
  },
  {
    id: 2,
    name: "Laptops",
    image: "/TopCategory/img.png",
    link: "/laptops",
  },
  {
    id: 3,
    name: "Watches",
    image: "/TopCategory/img.png",
    link: "/watches",
  },
  {
    id: 4,
    name: "Headphones",
    image: "/TopCategory/img.png",
    link: "/headphones",
  },
  {
    id: 5,
    name: "Shoes",
    image: "/TopCategory/img.png",
    link: "/shoes",
  },
  {
    id: 6,
    name: "Clothes",
    image: "/TopCategory/img.png",
    link: "/clothes",
  },
  {
    id: 7,
    name: "Home ",
    image: "/TopCategory/img.png",
    link: "/home-",
  },
  {
    id: 8,
    name: "Car",
    image: "/TopCategory/img.png",
    link: "/kitchen-",
  },
  {
    id: 8,
    name: "Bike",
    image: "/TopCategory/img.png",
    link: "/kitchen-",
  },
  {
    id: 8,
    name: "Truck",
    image: "/TopCategory/img.png",
    link: "/kitchen-",
  },
  {
    id: 8,
    name: "Plane",
    image: "/TopCategory/img.png",
    link: "/kitchen-",
  },
  {
    id: 8,
    name: "pet",
    image: "/TopCategory/img.png",
    link: "/kitchen-",
  },
  {
    id: 8,
    name: "bird",
    image: "/TopCategory/img.png",
    link: "/kitchen-",
  },
  {
    id: 8,
    name: "doll",
    image: "/TopCategory/img.png",
    link: "/kitchen-",
  },
];


export default DATA;